import Image from 'next/image';
import styled from 'styled-components';

import { Text } from './text';

const AvatarWrapper = styled.div`
  position: relative;
  width: ${(props) => (props.small ? '2rem' : '2.5rem')};
  height: ${(props) => (props.small ? '2rem' : '2.5rem')};
  max-width: ${(props) => (props.small ? '2rem' : '2.5rem')};
  max-height: ${(props) => (props.small ? '2rem' : '2.5rem')};
  border-radius: 1.25rem;
  border: 1px solid ${(props) => props.theme.noContrast};
  overflow: hidden;
`;

const AvatarImage = styled(Image)`
  object-fit: cover;
`;

const AvatarAndMoreWrapper = styled.div`
  position: relative;
  width: 2rem;
  height: 2rem;
  max-width: 2rem;
  max-height: 2rem;
  display: grid;
  place-content: center;
  border-radius: 1.25rem;
  border: 1px solid ${(props) => props.theme.noContrast};
  background-color: ${(props) => props.theme.primary};
`;

const AvatarAndMoreText = styled(Text)`
  color: ${(props) => props.theme.noContrast};
`;

export function Avatar(props) {
  return (
    <AvatarWrapper small={props.small}>
      <AvatarImage
        alt="Profielfoto"
        layout="fill"
        src={props.src ? props.src : '/icons/placeholder-avatar.svg'}
      />
    </AvatarWrapper>
  );
}

export function AvatarAndMore(props) {
  return (
    <AvatarAndMoreWrapper>
      <AvatarAndMoreText>{props.children}</AvatarAndMoreText>
    </AvatarAndMoreWrapper>
  );
}
